import {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState
} from 'react'
import {socket} from "../index"
import { useTheme } from './theme'
import { useAuth } from './auth'
import makeToast from '../components/toast'

interface TranslationFilesContext {
  speechTranslationFilesFW2: string[],
  webInterfaceTranslationFilesFW2: string[],
  speechTranslationFilesFW3: string[],
  webInterfaceTranslationFilesFW3: string[],
  IBTGTranslationFiles: string[],
  error: string
}

const TranslationFiles = createContext({} as TranslationFilesContext)

export default function TranslationFilesProvider(
  { children }: { children: ReactNode }
) {
  const [speechTranslationFilesFW2, setSpeechTranslationFilesFW2] = useState<string[]>([])
  const [webInterfaceTranslationFilesFW2, setWebInterfaceTranslationFilesFW2] = useState<string[]>([])
  const [speechTranslationFilesFW3, setSpeechTranslationFilesFW3] = useState<string[]>([])
  const [webInterfaceTranslationFilesFW3, setWebInterfaceTranslationFilesFW3] = useState<string[]>([])
  const [IBTGTranslationFiles, setIBTGTranslationFiles] = useState<string[]>([])
  const [error, setError] = useState<string>('')
  const {
    currentRole,
    availableSpeechTranslationFiles,
    availableWebInterfaceTranslationFiles
  } = useAuth()
  const {mode} = useTheme()

  const updateTranslationFiles = (
    globalAdmin: boolean,
    availableSpeechTranslationFilesString: string,
    availableWebInterfaceTranslationFilesString: string
  ) => {
    socket.emit('get_translation_files', globalAdmin, availableSpeechTranslationFilesString, availableWebInterfaceTranslationFilesString)
  }

  useEffect(() => {
    const translationFilesReceived = function (data: any) {
      if (data.error) {
        if (currentRole !== undefined && (currentRole.includes("Translator") || currentRole === "Global Administrator")) {
          makeToast('error', 'An error has occured.', mode)
        }
        setError(data.error)
      } else {
        setSpeechTranslationFilesFW2([...data.availableSpeechTranslationFilesListFW2])
        setWebInterfaceTranslationFilesFW2([...data.availableWebInterfaceTranslationFilesListFW2])
        setSpeechTranslationFilesFW3([...data.availableSpeechTranslationFilesListFW3])
        setWebInterfaceTranslationFilesFW3([...data.availableWebInterfaceTranslationFilesListFW3])
        setIBTGTranslationFiles([...data.availableIBTGTranslationFilesList])
      }
    }
    socket.on('translation_files_received', translationFilesReceived)
    return () => {
      socket.off('translation_files_received', translationFilesReceived)
    }
  }, [mode, currentRole])

  useEffect(() => {
    updateTranslationFiles(currentRole === "Global Administrator", availableSpeechTranslationFiles, availableWebInterfaceTranslationFiles)
    return () => {
      socket.off('translation_files_list_modified')
    }
  }, [currentRole, availableSpeechTranslationFiles, availableWebInterfaceTranslationFiles])

  useEffect(() => {
    socket.on('translation_files_list_modified', () => {
      updateTranslationFiles(currentRole === "Global Administrator", availableSpeechTranslationFiles, availableWebInterfaceTranslationFiles)
    })
    return () => {
      socket.off('translation_files_list_modified')
    }
  }, [currentRole, mode, availableSpeechTranslationFiles, availableWebInterfaceTranslationFiles])

  return (
    <TranslationFiles.Provider
      value={{
        speechTranslationFilesFW2,
        webInterfaceTranslationFilesFW2,
        speechTranslationFilesFW3,
        webInterfaceTranslationFilesFW3,
        IBTGTranslationFiles,
        error
      }}
    >
      {children}
    </TranslationFiles.Provider>
  )
}

export const useTranslationFiles = () => useContext(TranslationFiles)